import PlainSelect from 'app/common/ui/PlainSelect';
import withRoles from './withRoles';


export default withRoles(PlainSelect);
